// import { Component } from '@angular/core';

// @Component({
//   selector: 'app-user-type-selection-modal-component',
//   imports: [],
//   templateUrl: './user-type-selection-modal-component.component.html',
//   styleUrl: './user-type-selection-modal-component.component.css'
// })
// export class UserTypeSelectionModalComponentComponent {

// }


import { Component, NgModule, OnInit } from '@angular/core';
import { MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { MatDialogActions } from '@angular/material/dialog';
import { MatRadioGroup } from '@angular/material/radio';

import { UserTypeEnum } from 'src/app/shared/common/common.enum';
import {AppIconPaths} from 'src/app/shared/common/app-icon.path';
import { MatCard } from '@angular/material/card';

import { MatButton } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { NgFor,TitleCasePipe } from '@angular/common';

@Component({
  selector: 'app-user-type-selection-modal',
  templateUrl: './user-type-selection-modal-component.component.html',
  imports: [MatDialogActions, MatDialogContent, MatCard, MatButton, FormsModule,NgFor,TitleCasePipe],
  styleUrl: './user-type-selection-modal-component.component.css'
})
export class UserTypeSelectionModalComponent implements OnInit{
  selectedOption: string = 'Internal';
  appIconPaths = AppIconPaths;

  userTypeEnum = UserTypeEnum;
    // selectedUserType: UserTypeEnum = UserTypeEnum.internal;
    selectedUserType!: UserTypeEnum;
  
    userTypeOptions: { label: string; value: string }[] = [
      { label: UserTypeEnum.internal, value: UserTypeEnum.internal },
      { label: UserTypeEnum.external, value: UserTypeEnum.external },
    ];

  constructor(private dialogRef: MatDialogRef<UserTypeSelectionModalComponent>) {}

  ngOnInit(): void {
    
    //console.log('UserTypeSelectionModalComponent initialized with userTypeOptions:', this.userTypeOptions);
  }
  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    this.dialogRef.close(this.selectedUserType);
  }
}
